import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardList, Plus, Eye, MapPin, Users } from "lucide-react";
import api from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { customerMenu } from "@/config/menus";
import { PageHeader } from "@/components/KpiCard";
import { Button } from "@/components/ui/button";
import { StatusPill, LoadingScreen, EmptyState } from "@/components/common";

export default function Requirements() {
  const navigate = useNavigate();
  const [reqs, setReqs] = useState(null);
  useEffect(() => { api.get("/requirements/mine").then((r) => setReqs(r.data)).catch(() => setReqs([])); }, []);

  return (
    <DashboardShell menu={customerMenu} title="My Requirements">
      <PageHeader title="Security Requirements" subtitle="Track your posted requirements and compare quotations."
        action={<Button className="bg-brand hover:bg-brand-600" onClick={() => navigate("/post-requirement")} data-testid="new-req-btn"><Plus size={16} className="mr-1" /> New Requirement</Button>} />
      {!reqs ? <LoadingScreen /> : reqs.length === 0 ? (
        <EmptyState icon={ClipboardList} title="No requirements yet" hint="Post your first security requirement to receive quotations from verified agencies."
          action={<Button className="mt-4 bg-navy-900" onClick={() => navigate("/post-requirement")}>Post Requirement</Button>} />
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {reqs.map((r) => (
            <div key={r.id} className="card-lift bg-white border border-navy-200 rounded-xl p-5" data-testid={`req-card-${r.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-heading font-semibold text-navy-900">{r.security_requirement}</h3>
                  <p className="text-sm text-navy-500">{r.company_name || "Personal"}</p>
                </div>
                <StatusPill status={r.status} />
              </div>
              <div className="flex items-center gap-4 mt-3 text-sm text-navy-600">
                <span className="flex items-center gap-1"><MapPin size={14} /> {r.location}</span>
                <span className="flex items-center gap-1"><Users size={14} /> {r.num_guards} guards</span>
                <span>{r.contract_duration_months} months</span>
              </div>
              <Button variant="outline" className="w-full mt-4 border-navy-300" onClick={() => navigate(`/requirements/${r.id}`)} data-testid={`view-req-${r.id}`}>
                <Eye size={15} className="mr-1" /> View quotations
              </Button>
            </div>
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
